import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const PinPad: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--pin-pad')}
    viewBox="0 0 94 69"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Payment"
        transform="translate(-334.000000, -272.000000)"
        fill="#B7B7B7"
        fillRule="nonzero"
      >
        <g id="payment-icon" transform="translate(334.000000, 272.000000)">
          <path
            d="M86.1666667,0 L20.3666667,0 C16.0422689,0.00536004545 12.5386882,3.51232915 12.5333333,7.84090909 L12.5333333,9.40909091 L7.83333333,9.40909091 C3.5089356,9.41445095 0.0053548275,12.9214201 0,17.25 L0,61.1590909 C0.0053548275,65.4876708 3.5089356,68.99464 7.83333333,69 L73.6333333,69 C77.9577311,68.99464 81.4613118,65.4876708 81.4666667,61.1590909 L81.4666667,59.5909091 L86.1666667,59.5909091 C90.4910644,59.585549 93.9946451,56.0785799 94,51.75 L94,7.84090909 C93.9946451,3.51232915 90.4910644,0.00536004545 86.1666667,0 Z M3.13333333,17.25 C3.13333333,14.6519332 5.23777674,12.5454545 7.83333333,12.5454545 L73.6333333,12.5454545 C76.2288899,12.5454545 78.3333333,14.6519332 78.3333333,17.25 L78.3333333,20.3863636 L3.13333333,20.3863636 L3.13333333,17.25 Z M3.13333333,23.5227273 L78.3333333,23.5227273 L78.3333333,26.6590909 L3.13333333,26.6590909 L3.13333333,23.5227273 Z M78.3333333,61.1590909 C78.3333333,63.7571577 76.2288899,65.8636364 73.6333333,65.8636364 L7.83333333,65.8636364 C5.23777674,65.8636364 3.13333333,63.7571577 3.13333333,61.1590909 L3.13333333,29.7954545 L78.3333333,29.7954545 L78.3333333,61.1590909 Z M90.8666667,51.75 C90.8666667,54.3480668 88.7622233,56.4545455 86.1666667,56.4545455 L81.4666667,56.4545455 L81.4666667,17.25 C81.4613118,12.9214201 77.9577311,9.41445095 73.6333333,9.40909091 L15.6666667,9.40909091 L15.6666667,7.84090909 C15.6666667,5.24284229 17.7711101,3.13636364 20.3666667,3.13636364 L86.1666667,3.13636364 C88.7622233,3.13636364 90.8666667,5.24284229 90.8666667,7.84090909 L90.8666667,51.75 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default PinPad;
